export default "__VITE_PUBLIC_ASSET__2b6ed6e2__"